<!-- 工单报价审核 -->
<template>
  <el-dialog title="报价审核" :visible.sync="dialogIsShow" width="30%" :close-on-click-modal="false" ref="dialog"
    append-to-body>
    <el-form label-position="left" label-width="120px">
      <el-form-item label="上游报价备注：" v-if="jobUpOfferId > 0" size="medium" class="item-width"
        style="width: 100% !important ">
        <el-input placeholder="请输入备注" type="textarea" size="medium" :autosize="{ minRows: 3 }" style="width: 100%"
          v-model="remark1" :maxlength="300" :show-word-limit="true"></el-input>
      </el-form-item>
      <el-form-item label="下游报价备注：" v-if="jobDownOfferId > 0" size="medium" class="item-width"
        style="width: 100% !important ">
        <el-input placeholder="请输入备注" type="textarea" size="medium" :autosize="{ minRows: 3 }" style="width: 100%"
          v-model="remark2" :maxlength="300" :show-word-limit="true"></el-input>
      </el-form-item>
      <el-form-item label="审核状态：" size="medium" class="item-width" style="width: 100% !important;"
        :style="{ color: (isPass == 1 ? 'blue' : 'red') }">
        {{ (isPass == 1 ? "审核通过" : "审核拒绝") }}
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button v-if="isPass == 1" type="primary" size="small" @click="submitAudit(1)">确认通过</el-button>
      <el-button v-else type="danger" size="small" @click="submitAudit(0)" style="margin-left: 120px;">确认拒绝</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { AuditJobOffer } from "@/service/job";
export default {
  data() {
    return {
      dialogIsShow: false,

      jobId: 0,

      isPass: 0, //上传的文件
      jobUpOfferId: 0,
      jobDownOfferId: 0,
      remark1: "",
      remark2: ""
    };
  },
  created() {

    this.engQuotedPriceFileUrl = "";
    this.remark = "";
    console.log("this.remark2:" + this.remark);
  },
  methods: {
    openDia(jobId, isPass, jobUpOfferId, jobDownOfferId) {
      this.jobId = jobId;
      this.dialogIsShow = true;

      this.isPass = isPass;
      this.jobUpOfferId = jobUpOfferId;
      this.jobDownOfferId = jobDownOfferId;
      this.remark1 = "";
      this.remark2 = "";
      console.log("this.remark:" + this.remark);
    },

    //提交审核
    submitAudit(isPass) {

      let data = {};
      data.JobId = this.jobId;

      var upOfferId = [];
      var downOfferId = [];
      if (this.jobUpOfferId > 0) {
        upOfferId.push(this.jobUpOfferId);
      }
      if (this.jobDownOfferId > 0) {
        downOfferId.push(this.jobDownOfferId);
      }
      data.JobUpOfferId = upOfferId;
      data.JobDownOfferId = downOfferId;
      data.IsPass = (isPass == 1);
      data.Remark1 = this.remark1;
      data.Remark2 = this.remark2;

      // if (data.FileUrl == "") {
      //   return this.$message.warning('请选择报价图');
      // }
      console.log('data:' + JSON.stringify(data));

      AuditJobOffer(data).then((res) => {
        if (res.Result != 1) {
          return this.$message.error(res.Message);
        }
        this.$message.success(res.Message);
        this.dialogIsShow = false;
        this.$emit("reloadJobDetail");
      });
    },
  },
};
</script>

<style></style>